/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { TextField } from "src/components";
import Autocomplete from "src/components/Autocomplete";
import VwGnlRoldbKullaniciDTO from "src/models/RolYetki/VwGnlRoldbKullaniciDTO";
import { useGetGnlRoldbKullaniciQuery } from "src/services/Yetki/RolDbService";
import { useAppSelector } from "src/store";
import VtysGrupEnum from "src/enums/VtysGrupEnum";
import { helper } from "src/utils/helper";
import { AutoCompleteTargetNumber } from "../Types/autocomplete.target";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { AutocompleteChangeReason } from "@mui/base";
import ModulEnum from "src/enums/ModulEnum";
import { isVisible } from "src/utils/formAuthHelper";

interface IRolDbAutoComplete {
    onChange?: (e: AutoCompleteTargetNumber, v: VwGnlRoldbKullaniciDTO, reason?: AutocompleteChangeReason) => void;
    label?: string;
    helperText?: string;
    error?: boolean;
    value: number;
    name?: string;
    required?: boolean;
    vtysgrup: VtysGrupEnum;
    placeHolder?: string;
    ikazIcon?: boolean;
    authCode?: string;
    modul?: ModulEnum;
}
const RolDbAutoComplete = (props: IRolDbAutoComplete): JSX.Element => {
    const { organizasyon } = useAppSelector(s => s.userOrganizasyon)
    const { userInfo } = useAppSelector(s => s.userLogin)
    const query = useGetGnlRoldbKullaniciQuery({
        bagliorganizasyonId: organizasyon.bagliId,
        kullaniciId: userInfo.id,
        vtysgrup: props.vtysgrup
    }, { skip: !props.vtysgrup })

    const [value, setValue] = useState(null)

    useEffect(() => {
        setValue(query.data?.find(f => f?.id === props.value));
    }, [props.value]);


    useEffect(() => {
        if (!query.isFetching && !props.value && query.data?.length === 1) {
            var bul = query.data?.at(0);
            if (props.onChange) {
                props.onChange({ target: { value: bul?.id, name: props.name } }, bul);
                setValue(bul)
            }
        }
    }, [query.isFetching]);

    return (
        isVisible(props.authCode, props.modul) && (
            <Autocomplete
                multiple={false}
                freeSolo={false}
                value={value}
                options={query.data?.filter(f => f.aktif === "E") || []}
                isOptionEqualToValue={(o, s) => o?.id === s?.id}
                filterOptions={(option, state) => {
                    return option?.filter(
                        (f) =>
                            helper.UpperCaseAsc(f.adi)?.indexOf(helper.UpperCaseAsc(state.inputValue)) > -1
                    );
                }}
                getOptionLabel={(option) => {
                    if (!option?.adi)
                        return '';
                    return option.adi;
                }}
                renderOption={(props, option) => {
                    if (!option?.id) return '';
                    return (
                        <li {...props} key={option.id}>
                            {option.adi}
                        </li>
                    );
                }}
                onChange={(e, v, r, d) => {
                    setValue(v)
                    if (props.onChange) {
                        props.onChange({ target: { value: v?.id || null, name: props.name } }, v, r);
                    }
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        placeholder={props.placeHolder}
                        label={props.label}
                        error={props.error || query.isError}
                        required={props.required}
                        helperText={props.helperText || (query.isError && query.error.message)}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {props.ikazIcon && !value &&
                                        <FontAwesomeIcon icon={faCircleExclamation} beatFade size="lg" style={{ color: 'red' }} />
                                    }
                                    {params.InputProps.endAdornment}
                                </>
                            )
                        }}
                    />
                )}
            />
        )
    );
}
export default RolDbAutoComplete